// --------------------------------------------------------------
// Created On: 2024-08-23
// Author: KC Willard
//
// Last Modified: 2026-07-28
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------
import React, { Fragment } from "react";
import styles from "./Breadcrumbs.module.scss";

// A series of interactive breadcrumbs that supports navigation and highlights the current section.
export default function Breadcrumbs(props: Props): Component {
  return (
    <p className={styles.body}>
      {props.breadcrumbs.map((breadcrumb, i) => (
        <Fragment key={i}>
          <span
            data-test="breadcrumb-item"
            className={`${styles.breadcrumb} ${props.activePageNumber === i + 1 ? styles.selectedBreadcrumb : ""}`}
            onClick={() => props.onClick(i + 1)}
          >
            {breadcrumb}
          </span>
          {i + 1 < props.breadcrumbs.length && <span className="mx-2">&gt;</span>}
        </Fragment>
      ))}
    </p>
  );
}

interface Props {
  breadcrumbs: string[];
  activePageNumber: number;
  onClick: (pageNumber: number) => void;
}
